import { inject } from "aurelia-framework";
import { HttpClient } from "aurelia-http-client";

@inject(HttpClient)
export class BrandVideoAPI {
  constructor(http) {
    this.http = http;
  }

  save(data, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Authorization", token);
    });

    this.http.post("api/brandVideo/save", JSON.stringify(data)).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("brandVideo")) successCallback(json.brandVideo);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  updateVideoName(id, videoName, token, successCallback, errorCallback) {
    var data = {
      id: id,
      video_name: videoName,
    };

    console.log("brand video data", data);
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.post("api/brandVideo/updateName", data).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("brandVideo")) successCallback(json.brandVideo);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  updateVideoTopic(id, videoTopic, token, successCallback, errorCallback) {
    var data = {
      id: id,
      video_topic: videoTopic,
    };

    console.log("brand video data", data);
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.post("api/brandVideo/updateTopic", data).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("brandVideo")) successCallback(json.brandVideo);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getById(id, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    this.http.get("api/brandVideo/getById/" + id).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("brandVideo")) successCallback(json.brandVideo);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  getList(
    page,
    limit,
    sortBy,
    sortDir,
    myVideo,
    search,
    token,
    successCallback,
    errorCallback
  ) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    var queryString = "?page=" + page;
    queryString += "&limit=" + limit;
    queryString += "&sortBy=" + sortBy;
    queryString += "&sortDir=" + sortDir;
    queryString += "&myVideo=" + myVideo;
    queryString += "&search=" + search;

    this.http.get("api/brandVideo/getList" + queryString).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("brandVideos"))
          successCallback(json.brandVideos);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  acceptTestimonial(data, ctaFile, token, successCallback, errorCallback) {
    var formData = new FormData();
    formData.append("data", JSON.stringify(data));
    if (ctaFile != null) formData.append("cta", ctaFile);

    var http = new HttpClient().configure((x) => {
      x.withHeader("Authorization", token);
    });

    http.post("api/brandVideo/acceptTestimonial", formData).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("brandVideo")) successCallback(json.brandVideo);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  deleteTestimonial(data, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Authorization", token);
    });

    this.http
      .post("api/brandVideo/deleteTestimonial", JSON.stringify(data))
      .then((data) => {
        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("brandVideo"))
            successCallback(json.brandVideo);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  generateTranscript(id, token, successCallback, errorCallback) {
    var http = new HttpClient().configure((x) => {
      x.withHeader("Authorization", token);
      x.withTimeout(1000);
    });

    http
      .post("api/brandVideo/generateTranscript/" + id, {})
      .then((data) => {
        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("transcript"))
            successCallback(json.transcript);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else {
          errorCallback(data.statusText);
        }
      })
      .catch((error) => {
        if (error.name === "TimeoutError") {
          errorCallback("The request timed out. Please try again later.");
          alert("The request timed out. Please try again later.");
          this.generateTranscript(id, token, successCallback, errorCallback);
        } else {
          errorCallback("An error occurred: " + error.message);
        }
      });
  }
  reproduce(data, ctaFile, token, successCallback, errorCallback) {
    var formData = new FormData();
    formData.append("data", JSON.stringify(data));
    if (ctaFile != null) formData.append("cta", ctaFile);

    var http = new HttpClient().configure((x) => {
      x.withHeader("Authorization", token);
    });

    http.post("api/brandVideo/reproduce", formData).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("brandVideo")) successCallback(json.brandVideo);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }
  recreate(data, ctaFile, token, successCallback, errorCallback) {
    console.log("recreate data=>", data);

    var formData = new FormData();
    formData.append("data", JSON.stringify(data));
    if (ctaFile != null) formData.append("cta", ctaFile);

    var http = new HttpClient().configure((x) => {
      x.withHeader("Authorization", token);
    });

    http.post("api/brandVideo/recreate", formData).then((data) => {
      if (data.isSuccess) {
        var json = JSON.parse(data.response);

        if (json.hasOwnProperty("brandVideo")) successCallback(json.brandVideo);

        if (json.hasOwnProperty("error")) errorCallback(json.error);
      } else {
        errorCallback(data.statusText);
      }
    });
  }

  setPublic(id, value, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Authorization", token);
    });

    this.http
      .post("api/brandVideo/setPublic", { id: id, value: value })
      .then((data) => {
        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("public")) successCallback(json.public);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  setFeatured(id, value, token, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Authorization", token);
    });

    this.http
      .post("api/brandVideo/setFeatured", { id: id, value: value })
      .then((data) => {
        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("featured")) successCallback(json.featured);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else {
          errorCallback(data.statusText);
        }
      });
  }
}
